import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Home', href: '#hero' },
    { label: 'Servizi', href: '#servizi' },
    { label: 'Galleria', href: '#galleria' },
    { label: 'Chi Siamo', href: '#chi-siamo' },
    { label: 'Contatti', href: '#contatti' },
  ];

  const handleAnchor = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#08080c]/95 backdrop-blur-md border-b border-red-900/30' : 'bg-transparent'
      }`}
    >
      <div className="px-6 md:px-12 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <div className="relative">
            <span className="font-['Exo_2'] font-black text-white text-xl md:text-2xl tracking-widest uppercase">
              ELLE NOLO
            </span>
            <div className="absolute -bottom-1 left-0 right-0 h-[2px] bg-gradient-to-r from-red-600 via-orange-500 to-transparent" />
          </div>
          <span className="font-['Exo_2'] font-light text-gray-400 text-xs tracking-[0.3em] uppercase hidden sm:block">
            Equipment
          </span>
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleAnchor(e, link.href)}
              className="font-['Exo_2'] text-sm text-gray-300 hover:text-white tracking-widest uppercase transition-all duration-300 hover:text-red-400 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* Contact Pills */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:+390550620108"
            className="flex items-center gap-2 px-3 py-1.5 border border-red-800/50 rounded-full text-xs text-gray-300 hover:border-red-500 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-red-500 text-xs" />
            </div>
            +39 055 0620108
          </a>
          <a
            href="mailto:ellenoloequipmentsrl@gmail.com"
            className="flex items-center gap-2 px-3 py-1.5 border border-orange-800/50 rounded-full text-xs text-gray-300 hover:border-orange-500 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-line text-orange-500 text-xs" />
            </div>
            Email
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#08080c]/98 border-t border-red-900/30 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleAnchor(e, link.href)}
              className="font-['Exo_2'] text-sm text-gray-300 hover:text-red-400 tracking-widest uppercase transition-colors cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a href="tel:+390550620108" className="text-sm text-gray-400 cursor-pointer">+39 055 0620108</a>
          <a href="mailto:ellenoloequipmentsrl@gmail.com" className="text-sm text-gray-400 cursor-pointer">ellenoloequipmentsrl@gmail.com</a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
